import React from 'react';
import DotsLoading from '../../../components/dotsLoading';
import {useParams} from 'react-router-dom';
import useGetLoadingTransactionPlan from '../../../services/hookService/my-account/getLoadingTransaction/useGetLoadingTransactionPlam';

const PaymentPlanLoading = () => {
  const {guid, ipg_type} = useParams();
  useGetLoadingTransactionPlan({
    transaction_guid: guid,
    ipg_type: ipg_type || '',
  });
  return (
    <div className="w-full h-full flex flex-col bg-white justify-center items-center">
      <DotsLoading />
    </div>
  );
};

export default PaymentPlanLoading;
